(function () {
  var els = [].slice.call(document.querySelectorAll('.gsk-rv'));
  if (!els.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('gsk-motion');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('gsk-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  els.forEach(function (el) {
    var i = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
    el.style.setProperty('--gsk-d', Math.min(i, 8) * 60 + 'ms');
    io.observe(el);
  });
  setTimeout(function () { els.forEach(function (el) { el.classList.add('gsk-in'); }); }, 4000);
})();
